import { livingArrangementsTypes, employmentTypes } from "../../../constants";
import criteria from "../../../utils/criteria";

const { PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS } = livingArrangementsTypes;

const { SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL, BENEFITS } = employmentTypes;

const {
  assetType,
  loanAmountBetween,
  employmentType,
  timeOfEmploymentGreaterThan,
  livingArrangements,
  creditScoreBetween,
  termIsLessThanOrEqualTo,
} = criteria;

const gold = [
  {
    name: "Gold - New/Demo",
    rate: 16.95,
    productType: "Adverse",
    info: ["Min score >550, allows for 2 or less defaults but not ex-bankrupts"],
    criteria: [
      loanAmountBetween(5000, 6000),

      termIsLessThanOrEqualTo(24),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreBetween(550, 600),
    ],
  },

  {
    name: "Gold - New/Demo",
    rate: 16.95,
    productType: "Adverse",
    info: ["Min score >550, allows for 2 or less defaults but not ex-bankrupts"],
    criteria: [
      loanAmountBetween(6000, 8000),

      termIsLessThanOrEqualTo(36),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreBetween(550, 600),
    ],
  },

  {
    name: "Gold - New/Demo",
    rate: 16.95,
    productType: "Adverse",
    info: ["Min score >550, allows for 2 or less defaults but not ex-bankrupts"],
    criteria: [
      loanAmountBetween(8000, 15000),

      termIsLessThanOrEqualTo(48),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreBetween(550, 600),
    ],
  },

  {
    name: "Gold - New/Demo",
    rate: 16.95,
    productType: "Adverse",
    info: ["Min score >550, allows for 2 or less defaults but not ex-bankrupts"],
    criteria: [
      loanAmountBetween(15000, 30000),

      termIsLessThanOrEqualTo(60),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreBetween(550, 600),
    ],
  },

  {
    name: "Gold - New/Demo",
    rate: 16.95,
    productType: "Adverse",
    info: ["Min score >550, allows for 2 or less defaults but not ex-bankrupts"],
    criteria: [
      loanAmountBetween(30000, 65000),

      termIsLessThanOrEqualTo(72),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreBetween(550, 600),
    ],
  },

  {
    name: "Gold Micro - New/Demo",
    rate: 16.95,
    productType: "Adverse",
    info: ["Min score >550, allows for 2 or less defaults but not ex-bankrupts"],
    criteria: [
      loanAmountBetween(2000, 6000),

      termIsLessThanOrEqualTo(24),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([BENEFITS]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreBetween(550, 600),
    ],
  },

  {
    name: "Gold Micro - New/Demo",
    rate: 16.95,
    productType: "Adverse",
    info: ["Min score >550, allows for 2 or less defaults but not ex-bankrupts"],
    criteria: [
      loanAmountBetween(6000, 8000),

      termIsLessThanOrEqualTo(36),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([BENEFITS]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreBetween(550, 600),
    ],
  },

  {
    name: "Gold Micro - New/Demo",
    rate: 16.95,
    productType: "Adverse",
    info: ["Min score >550, allows for 2 or less defaults but not ex-bankrupts"],
    criteria: [
      loanAmountBetween(8000, 12000),

      termIsLessThanOrEqualTo(48),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([BENEFITS]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreBetween(550, 600),
    ],
  },
];
export default gold;
